<template>
    <div align="center">
        <div style="margin: 15px;">
            <span>信息</span>
        </div>
        <div class="commonSearch" ref="commonSearchRef" :style="'height:' + (tabHeight + 30) + 'px'">
            <el-form   v-if="rsList.length>0"  v-for="(item,index) in this.rsList" :key="index" class="spHeight" label-width="150px" label-position="right" ref="form">
                <el-form-item label="报修单号："> {{item.repaircode}} </el-form-item>
                <el-form-item label="故障类型："> {{item.faulttypeName}} </el-form-item>
                <el-form-item label="操作类型："> {{item.status == 100404 ? "反馈" : "评价"}} </el-form-item>
                <el-form-item label="总体满意度：">
                    <el-rate v-model="item.satisfaction" disabled> </el-rate>
                </el-form-item>
                <el-form-item label="服务态度：">
                    <el-rate v-model="item.attitude" disabled> </el-rate>
                </el-form-item>
                <el-form-item label="服务质量：">
                    <el-rate v-model="item.quality" disabled> </el-rate>
                </el-form-item>
                <el-form-item label="是否守时：">
                    <el-rate v-model="item.punctual" disabled> </el-rate>
                </el-form-item>
                <el-form-item label="服务收费：">
                    <el-rate v-model="item.charge" disabled> </el-rate>
                </el-form-item>
                <el-form-item label="反馈描述：" v-if="item.status == 100404">
                    <el-input type="textarea" :rows="6" v-model="item.feedbacktext" disabled style="width: 500px;"> </el-input>
                </el-form-item>
                <el-form-item label="评价描述：" v-if="item.status == 100405">
                    <el-input type="textarea" :rows="6" v-model="item.evaluatetext" disabled style="width: 500px;"> </el-input>
                </el-form-item>

                <el-form-item label="图片：" v-if="(item.images && item.images.length > 0)">
                    <div class="block" v-for="(o, i) in item.images" :key="i">
                        <img style="width:500px;height:auto;" :src="o.src" />
                    </div>
                </el-form-item>
                <!--  -->
                <el-form-item label="追评内容：" >
                    <div class="more-evaluate">
                        <div v-for="(i,key) in item.replys" :key="key">
                            <div class="item-evaluate" v-if="i.replyUserId != currentUser.id">
                                <span class="label">{{ i.replyUserName }}：</span><span class="value">{{ i.content }}</span>
                            </div>
                            <div class="item-evaluate" v-else>
                                <span class="label">{{ i.replyUserName }}：</span><span class="value">{{ i.content }}</span>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <!--  -->
                <el-form-item label="教师消息：" v-if="item.isShowReply">
                    <el-input type="textarea" :rows="6" v-model="replyVal" style="width: 500px;margin-bottom: 10px;"> </el-input>
                    <div>
                        <el-button  type="primary" size="mini" plain @click="confirmReply(item)" style="margin-left: 410px;">确认发送</el-button>
                    </div>
                </el-form-item>
            </el-form>
            
            <el-form v-if="replyArr.length>0" class="spHeight" label-width="150px" label-position="right" ref="form">
                <el-form-item label="评价内容：" v-if="replyArr.length>0">
                    <div class="more-evaluate">
                        <div v-for="(i,key) in replyArr" :key="key">
                            <div class="item-evaluate" v-if="i.replyUserId != currentUser.id">
                                <span class="label">{{ i.replyUserName }}：</span><span class="value">{{ i.content }}</span>
                            </div>
                            <div class="item-evaluate" v-else>
                                <span class="label">{{ i.replyUserName }}：</span><span class="value">{{ i.content }}</span>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <!--  -->
                <el-form-item label="教师消息：" v-if="replyArr.length>0">
                    <el-input type="textarea" :rows="6" v-model="replyVal" style="width: 500px;margin-bottom: 10px;"> </el-input>
                    <div>
                        <el-button  type="primary" size="mini" plain @click="confirmReply(item)" style="margin-left: 410px;">确认发送</el-button>
                    </div>
                </el-form-item>
            </el-form>

        

        <el-form v-if="replyArr.length==0&&rsList.length==0" class="spHeight" label-width="150px" label-position="right">
                 <el-form-item label="教师消息：">
                    <el-input type="textarea" :rows="6" v-model="replyVal" style="width: 500px;margin-bottom: 10px;"> </el-input>
                    <div>
                        <el-button  type="primary" size="mini" plain @click="confirmReply(item)" style="margin-left: 410px;">确认发送</el-button>
                    </div>
                </el-form-item>
            </el-form>

            <el-row>
                <el-col :span="18" align="center">
                    <el-button type="primary" plain size="90" @click="clea">返回</el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import TabResize from "@/utils/TabResizeEx.js";
import FaultApi from "@/api/fault.js";

export default {
    mixins: [TabResize],
    data () {
        return {
            rsList: [],
            fits: [],
            loading: true,
            status: "",
            info: "",
            currentUser:{},
            replyVal:"",//回复的字段
            rowObj:{},
            replyArr:[]
        };
    },
    mounted: function () { },
    created () {
        this.currentUser = this.$constant.GET_USER();
        this.rowObj=this.$route.params.row?this.$route.params.row:{};
        if(this.rowObj.status=='100402'){//维修中
            this.getReplyInfo(this.rowObj.orderid);
        }else{//已评价
            this.initData(this.rowObj.repaircode);
        }
    },

    methods: {
        initData (_repaircode) {
            this.rsList = [];
            let param = {
                repaircode: _repaircode
            };
            FaultApi.getClass()
                .qryOrderFeedback(param)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this.rsList = resp.data.data.map((item)=>({
                            ...item,
                            isShowReply:item.replys.length>0,//&&item.replys[item.replys.length-1].replyUserId != this.currentUser.id
                        }));

                        for (let i = 0; i < this.rsList.length; i++) {
                            this.uplodImage("9981", this.rsList[i].orderfeedbackid, i);
                        }
                    } else {
                        this.$message.error(resp.data.msg);
                        this.loading = false;
                        return false;
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.$message.error(err);
                    return false;
                });
        },
        getReplyInfo(orderid){         
            FaultApi.getClass()
                .getReplyInfoApi(orderid)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this.replyArr=resp.data.data
                        //     .map((item)=>({
                        //     ...item,
                        //     isShowReply:item.replys.length>0,//&&item.replys[item.replys.length-1].replyUserId != this.currentUser.id
                        // }));
                    } else {
                        this.$message.error(resp.data.msg);

                    }
                }).catch((err) => {

            });
        },
        uplodImage (typeid, id, index) {
            let recordId = id;
            let _this = this;
            FaultApi.getClass()
                .getFiles(typeid, recordId)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        let data = resp.data.data;
                        let pictures = [];
                        for (var i = 0; i < data.length; i++) {
                            pictures.push({ id: data[i].id, src: this.$constant.LOAD_FILE(_this, data[i].id) });
                        }
                        this.$set(_this.rsList[index], 'images', pictures)
                    } else {
                        this.$message.error(resp.data.msg);
                        this.loading = false;
                        return false;
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.$message.error(err);
                    return false;
                });
        },
        confirmReply(){
            let param = {
                orderfeedbackid:this.rowObj.orderid,
                content:this.replyVal,
            };
            FaultApi.getClass()
                .saveOrUpdateReply(param)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this.$message("保存成功");
                        this.clea()
                    } else {
                        this.$message.error(resp.data.msg);

                        return false;
                    }
                }).catch((err) => {
                this.$message.error(err);
                return false;
            });

        },
        clea () {
            this.$router.go(-1);
        }
    }
};
</script>

<style lang="stylus" scoped>
.commonSearch {
    width: 80%;
    overflow-y: auto;
}

.el-form-item {
    width: 80%;
    padding-top: 20px;
    text-align: left;
}

.spHeight {
    border-bottom: 1px solid blue;
    margin-bottom: 30px;
}

.spHeight >>> label {
    line-height: 20px;
}

.imgdiv {
    display: flex;
    border: 1px solid #000;
}

.block {
    width: 100px;
    height: 100px;
    margin-right: 10px;
    display: inline;
}
.more-evaluate{
    border:1px solid #ccc;
    width:480px;
    padding:0 10px;
    .item-evaluate{
        width: 100%;
        margin-left: 0;
        color: #999;
        font-size: 13px;
        .value{
            color: #333;
        }
    }
}
</style>